export const enUSMessages = {
  "app.name": "CraftForce",
  "account.accessRequiredBody":
    "You do not have access to this account surface in the current state.",
  "account.accessRequiredTitle": "Account unavailable",
  "account.identity.title": "Account identity",
  "account.lede":
    "Manage your language, gamer tag, and connected Clerk account.",
  "account.loading": "Loading account…",
  "account.nav.defaultName": "Account",
  "account.signInRequired": "Sign in to view your account.",
  "account.title": "Account",
  "admin.accessRequiredBody":
    "This area is only available to bootstrap admins.",
  "admin.accessRequiredTitle": "Admin access required",
  "admin.lede":
    "Review invites, moderation, safety telemetry, and admin-only usage data.",
  "admin.systemBattleBots.basicHelp":
    "Starter unit each player begins with in active/deck setup.",
  "admin.systemBattleBots.basicTitle": "Basic Battle Bot",
  "admin.systemBattleBots.betterHelp":
    "Permanent fallback recruit lane card. Recruit cost follows its derived cost ({cost}).",
  "admin.systemBattleBots.betterTitle": "Better Battle Bot",
  "admin.systemBattleBots.sparkHelp":
    "Starter unit each player begins with — gains 1 energy when played.",
  "admin.systemBattleBots.sparkTitle": "Spark Bot",
  "admin.systemBattleBots.description":
    "These are system cards, not normal library cards. New matches snapshot this config when they start.",
  "admin.systemBattleBots.editTitle": "Edit {name}",
  "admin.systemBattleBots.error.noSession":
    "You must be signed in to save system battle bots.",
  "admin.systemBattleBots.error.saveFailed":
    "Failed to save system battle bots.",
  "admin.systemBattleBots.eyebrow": "System cards",
  "admin.systemBattleBots.saved": "System battle bots saved.",
  "admin.systemBattleBots.saving": "Saving…",
  "admin.systemBattleBots.title": "Battle bots",
  "admin.title": "Admin",
  "app.authSetup.body":
    "Configure Clerk before protected routes and invite-only access can be tested.",
  "app.authSetup.bootstrapHelp":
    "Bootstrap admin emails unlock the admin surface. Player access should come from Clerk invitation links once Clerk restricted sign-up is enabled.",
  "app.authSetup.requiredEnv": "Required environment variables",
  "app.authSetup.title": "Auth setup required",

  "auth.accessClass": "Access class",
  "auth.accessGrantedTitle": "Access granted",
  "auth.accessSummary.bootstrapAdmin": "Bootstrap admin access is active.",
  "auth.accessSummary.invitedPlayer": "Invite-only access is active.",
  "auth.emailRequiredBody":
    "Your account needs a primary email address before CraftForce can verify access.",
  "auth.emailRequiredTitle": "Email required",
  "auth.inviteRequiredBody":
    "This build is invite-only. Your account is signed in, but it has not been approved for CraftForce access yet.",
  "auth.inviteRequiredTitle": "Invite required",
  "auth.loadingBody": "Checking your CraftForce access.",
  "auth.loadingTitle": "Loading account",
  "auth.nextMilestone": "Next milestone",
  "auth.nextMilestoneProfileBootstrap":
    "Player profile bootstrap in this environment.",
  "auth.signInBody":
    "CraftForce is currently invite-only. Sign in first, then the app will verify access.",
  "auth.signInButton": "Sign in",
  "auth.signInTitle": "Sign in to CraftForce",

  "cardEditor.createTitle": "Create card",
  "cardEditor.editTitle": "Edit card",
  "cardEditor.error.attackMin": "Attack must be 0 or more.",
  "cardEditor.error.healthMin": "Health must be 1 or more.",
  "cardEditor.error.maxCost":
    "Derived cost {cost} exceeds the maximum of {max}.",
  "cardEditor.error.maxCostTitle": "Derived cost exceeds the maximum of {max}.",
  "cardEditor.error.nameRequired": "Name is required.",
  "cardEditor.moderationLabel": "Card name",
  "cardEditor.validation.allyRequirementUnavailable":
    'Skill "{skillId}" does not support ally requirements.',
  "cardEditor.validation.costExceedsCap":
    "Derived cost {cost} exceeds the maximum of {max}.",
  "cardEditor.validation.derivedCostStale":
    "Stored derived cost {stored} does not match the computed value {computed}.",
  "cardEditor.validation.duplicateColor":
    "Secondary faction must differ from the primary faction.",
  "cardEditor.validation.duplicateSkill":
    'Skill "{skillId}" is selected more than once.',
  "cardEditor.validation.nonExhaustingUnavailable":
    'Skill "{skillId}" does not support the non-exhausting modifier.',
  "cardEditor.validation.selfDestructUnavailable":
    'Skill "{skillId}" does not support the overload modifier.',
  "cardEditor.validation.skillAffinityMismatch":
    'Skill "{skillId}" is not available for this faction combination.',
  "cardEditor.validation.surchargeMissing":
    "Cards with a secondary faction must set the secondary faction surcharge to 0.5.",
  "cardEditor.validation.surchargeUnexpected":
    "Cards without a paid secondary faction must set the secondary faction surcharge to 0.",
  "cardEditor.validation.unknownSkill": 'Unknown skill "{skillId}".',

  "cardFace.addSecondaryFaction": "Add secondary faction",
  "cardFace.clearSecondaryFaction": "Remove secondary faction",
  "cardFace.cost.dualFaction": "Dual faction",
  "cardFace.cost.skills": "Skills",
  "cardFace.cost.stats": "Stats",
  "cardFace.levelAria": "Level {level}",
  "cardFace.skill.ally.one": "Ally required",
  "cardFace.skill.ally.two": "Double ally required",
  "cardFace.skill.exhaust": "Exhaust to activate",
  "cardFace.skill.nonExhausting": "Non-exhausting",
  "cardFace.skill.overload": "Overload",
  "cardFace.stat.stepperAria": "{label} stepper",

  "common.accept": "Accept",
  "common.actions": "Actions",
  "common.active": "Active",
  "common.activatable": "Activatable",
  "common.add": "Add",
  "common.attack": "Attack",
  "common.cancel": "Cancel",
  "common.cards": "Cards",
  "common.challenges": "Challenges",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.cost": "Cost",
  "common.confirmDelete": "Confirm delete",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.create": "Create",
  "common.created": "Created",
  "common.deck": "Deck",
  "common.decks": "Decks",
  "common.decline": "Decline",
  "common.delete": "Delete",
  "common.dismiss": "Dismiss",
  "common.displayName": "Display name",
  "common.duplicate": "Duplicate",
  "common.edit": "Edit",
  "common.email": "Email",
  "common.entries": "Entries",
  "common.exhausted": "Exhausted",
  "common.faction": "Faction",
  "common.factions": "Factions",
  "common.gamerTag": "Gamer tag",
  "common.guard": "Guard",
  "common.health": "Health",
  "common.hero": "Hero",
  "common.language": "Language",
  "common.loading": "Loading…",
  "common.locked": "Locked",
  "common.name": "Name",
  "common.none": "None",
  "common.passive": "Passive",
  "common.pending": "Pending",
  "common.pilot": "Pilot",
  "common.players": "Players",
  "common.quit": "Quit",
  "common.reason": "Reason",
  "common.remove": "Remove",
  "common.report": "Report",
  "common.revoke": "Revoke",
  "common.role": "Role",
  "common.saveChanges": "Save changes",
  "common.selectedCount":
    "{count, plural, one {# selected} other {# selected}}",
  "common.send": "Send",
  "common.signedInEmail": "Signed-in email",
  "common.skills": "Skills",
  "common.status": "Status",
  "common.status.accepted": "accepted",
  "common.status.active": "active",
  "common.status.cancelled": "cancelled",
  "common.status.declined": "declined",
  "common.status.dismissed": "dismissed",
  "common.status.expired": "expired",
  "common.status.pending": "pending",
  "common.status.reviewed": "reviewed",
  "common.status.revoked": "revoked",
  "common.total": "Total",
  "common.turns": "Turns",
  "common.unknown": "Unknown",
  "common.unnamed": "Unnamed",
  "common.updated": "Updated",
  "common.value": "Value",
  "common.winner": "Winner",

  "deckEditor.addHero": "+ Hero",
  "deckEditor.cardCountSummary":
    "{total} / 24 ({unique, plural, one {# unique} other {# unique}})",
  "deckEditor.closeAria": "Close",
  "deckEditor.createTitle": "Create deck",
  "deckEditor.deckNameLabel": "Deck name",
  "deckEditor.deckNamePlaceholder": "e.g. Red Rush",
  "deckEditor.editTitle": "Edit deck",
  "deckEditor.emptyFilter": "No cards match the filter.",
  "deckEditor.error.deckNameRequired": "Deck name is required.",
  "deckEditor.error.exactCardCount":
    "Deck must have exactly 24 cards. Currently has {count}.",
  "deckEditor.error.heroRequired": "A hero must be selected.",
  "deckEditor.error.maxCopies": "Card {cardId} exceeds the 3-copy limit.",
  "deckEditor.filterPlaceholder": "Filter by name…",
  "deckEditor.heroPlaceholder": "— select hero —",
  "deckEditor.validation.duplicateEntry":
    'Card "{cardId}" appears more than once in the deck.',
  "deckEditor.validation.tooFewLowCost":
    "At least {min} merc cards must cost {threshold} or less. This deck has {count}.",
  "deckEditor.validation.tooManyHighCost":
    "At most {max} merc cards may cost {threshold} or more. This deck has {count}.",
  "deckEditor.validation.unknownCards":
    "{count, plural, one {# card in this deck could not be resolved. Save all cards before validating.} other {# cards in this deck could not be resolved. Save all cards before validating.}}",
  "deckEditor.removeOneAria": "Remove one {name}",
  "deckEditor.addOneAria": "Add one {name}",
  "deckEditor.randomDeck": "Random deck",
  "deckEditor.colorPreferenceAny": "Any color",

  "error.route.body":
    "This section encountered an unexpected error. You can try reloading it or navigate to a different section.",
  "error.route.retry": "Retry",
  "error.route.title": "Something went wrong",

  "filter.actions.apply": "Apply",
  "filter.actions.cancel": "Cancel",
  "filter.aria.clear": "Clear filter",
  "filter.aria.input": "Filter table rows",
  "filter.aria.suggestions": "Filter suggestions",
  "filter.appendValueTitle":
    "Cmd/Ctrl-click to add this value. Alt/Opt-click to exclude it.",
  "filter.fieldDetail": "Filter field",
  "filter.placeholder.cards":
    'Filter cards by text or key:value, e.g. faction:red skill:"Guard" cost:3',
  "filter.placeholder.decks":
    'Filter decks by text or key:value, e.g. hero:"Ironclad" cards:24',
  "filter.placeholder.generic":
    'Filter by text or key:value, e.g. faction:red skill:"Guard"',
  "filter.placeholder.heroes":
    "Filter heroes by text or key:value, e.g. faction:signal skill:guard attack:5",
  "filter.restoreError": "Could not restore the table filter from the URL.",

  "faction.blue": "Signal",
  "faction.colorless": "Colorless",
  "faction.green": "Thrive",
  "faction.purple": "Shadow",
  "faction.red": "Fury",
  "faction.yellow": "Command",

  "friends.acceptError.selectDeck": "Select a deck to play.",
  "friends.actionError.challengeUnavailable":
    "That challenge is no longer available.",
  "friends.actionError.initializeFailed":
    "Unable to initialize the match right now. Try again.",
  "friends.actionError.networkFailed":
    "Network error while starting the match. Check the server and retry.",
  "friends.actionError.playerSyncUnavailable":
    "That player is not available for online challenges yet. Ask them to open CraftForce once while signed in.",
  "friends.actionError.selectedDecksInvalid":
    "Unable to start the match with the selected decks right now.",
  "friends.alias.add": "Add nickname",
  "friends.alias.clear": "Clear nickname",
  "friends.alias.edit": "Edit nickname",
  "friends.alias.error.blocked": "That nickname contains blocked language.",
  "friends.alias.error.length":
    "Nicknames must be between 1 and 30 characters.",
  "friends.alias.label": "Your private nickname for this friend",
  "friends.alias.placeholder": "Optional private nickname",
  "friends.challengeAnother":
    "Challenge approved friends to a server-backed online match.",
  "friends.challengeCancel": "Cancel",
  "friends.challengeCancelReport": "Cancel report",
  "friends.challengeLabel": "Challenge",
  "friends.challengeSent": "Challenge sent",
  "friends.challenges.emptyReceived": "No pending challenges.",
  "friends.challenges.emptySent": "No challenges sent yet.",
  "friends.challenges.joinMatch": "Join match",
  "friends.challenges.received": "Received",
  "friends.challenges.sent": "Sent",
  "friends.challenges.startMatch": "Start match",
  "friends.deckPicker.label": "Your deck",
  "friends.deckPicker.placeholder": "— select deck —",
  "friends.friendsTab": "Friends",
  "friends.friendCode.alreadyFriends":
    "You are already friends with that player.",
  "friends.friendCode.enterLabel": "Friend code",
  "friends.friendCode.help":
    "Share this code so another invited player can send you a friend request.",
  "friends.friendCode.label": "Your friend code",
  "friends.friendCode.notFound":
    "That friend code could not be matched to an invited player.",
  "friends.friendCode.pendingExists":
    "There is already a pending friend request between you and that player.",
  "friends.friendCode.placeholder": "Enter a friend code",
  "friends.friendCode.regenerate": "Regenerate",
  "friends.friendCode.required": "Enter a friend code first.",
  "friends.friendCode.self": "You cannot send a friend request to yourself.",
  "friends.friendCode.send": "Send friend request",
  "friends.friendRequestNotification.body":
    "{requesterTag} sent you a friend request.",
  "friends.friendRequestNotification.title": "New friend request",
  "friends.inboxCallout.multiple":
    "{count} incoming challenges are waiting in your inbox.",
  "friends.inboxCallout.single": "{challengerTag} sent you a challenge.",
  "friends.inboxCallout.title": "Incoming challenges",
  "friends.joinPrompt": "Sign in to manage friends and send challenges.",
  "friends.loading": "Loading…",
  "friends.noProfile":
    "Complete your player profile in Settings before sending challenges.",
  "friends.noPlayers":
    "No approved friends yet. Share your friend code to start building your list.",
  "friends.notification.accepted": "Challenge with {playerTag} was accepted.",
  "friends.notification.body": "{challengerTag} sent you a challenge.",
  "friends.notification.cancelled": "Challenge with {playerTag} was cancelled.",
  "friends.notification.declined": "Challenge with {playerTag} was declined.",
  "friends.notification.statusTitle": "Challenge update",
  "friends.notification.title": "New challenge",
  "friends.openChallenges": "Open challenges",
  "friends.page.eyebrow": "Social",
  "friends.page.title": "Friends & Challenges",
  "friends.playerRecentlySeen": "Recently seen",
  "friends.playerSeenEarlier": "Seen earlier",
  "friends.playerUnavailable": "Unavailable",
  "friends.requests.emptyIncoming": "No incoming friend requests.",
  "friends.requests.emptyOutgoing": "No outgoing friend requests.",
  "friends.requests.incoming": "Incoming requests",
  "friends.requests.outgoing": "Outgoing requests",
  "friends.reportError.reasonTooShort":
    "Add a short reason so the admin can review it.",
  "friends.reportPlaceholder": "Describe the behavior you want reviewed.",
  "friends.reportReasonLabel": "Report reason",
  "friends.reportSent": "Report sent",
  "friends.selectDeckToChallenge": "Select a deck to challenge with.",
  "friends.sendChallenge": "Send challenge",
  "friends.submitReport": "Submit report",

  "heroEditor.addImageLevel": "Add L{level} image",
  "heroEditor.closeAria": "Close",
  "heroEditor.createTitle": "Create hero",
  "heroEditor.editTitle": "Edit hero",
  "heroEditor.emptyArtworkLevel": "No level {level} artwork yet",
  "heroEditor.error.attack": "Level {level}: attack must be 0 or more.",
  "heroEditor.error.duplicateSkill": "Level {level}: duplicate skill selected.",
  "heroEditor.error.health": "Level {level}: health must be 1 or more.",
  "heroEditor.error.nameRequired": "Name is required.",
  "heroEditor.validation.duplicateColor":
    "Hero secondary faction must differ from the primary faction.",
  "heroEditor.validation.invalidProgressionOrder":
    "Hero progression must contain levels 1, 2, and 3 in order.",
  "heroEditor.validation.skillAffinityMismatch":
    'Skill "{skillId}" is not available for level {level}.',
  "heroEditor.validation.tooManySkills":
    "Level {level} may have at most {max} skills.",
  "heroEditor.validation.unknownSkill":
    'Unknown skill "{skillId}" on level {level}.',
  "heroEditor.levelArtworkReady": "Level {level} artwork ready",
  "heroEditor.moderationLabel": "Hero name",
  "heroEditor.replaceImageLevel": "Replace L{level} image",
  "heroEditor.randomize": "Randomize stats",
  "heroEditor.upgradeLabel": "to upgrade",

  "moderation.error.blockedLanguage": "{label} contains blocked language.",

  "invites.activeSummary":
    "{activeCount, plural, one {# active invite} other {# active invites}}{revokedCount, plural, =0 {} one {, # revoked} other {, # revoked}}",
  "invites.createError.alreadyExists":
    "An active invite already exists for this email.",
  "invites.createError.emailRequired": "Email is required.",
  "invites.createError.generic": "Failed to create invite.",
  "invites.createError.invalidEmail": "Enter a valid email address.",
  "invites.copyError": "Failed to copy invite link.",
  "invites.emailPlaceholder": "pilot@example.com",
  "invites.emailToInvite": "Email to grant access",
  "invites.empty": "No invites yet. Create one above.",
  "invites.fetchError.generic": "Failed to load invites.",
  "invites.fetchError.unauthorized":
    "Sign in as a bootstrap admin to manage invites.",
  "invites.lede":
    "Create real Clerk invitation links for players. An invited player can use the link to sign up or sign in, and the invitation grants CraftForce access.",
  "invites.linkHelp":
    "This creates a Clerk invitation link and copies it for you to share manually.",
  "invites.page.eyebrow": "Admin",
  "invites.page.title": "Invite management",
  "invites.reactivate": "Reactivate",
  "invites.revokeError": "Failed to revoke invite.",
  "invites.sendInvite": "Create invite",

  "library.error.deleteFailed": "Library delete failed.",
  "library.error.fetchFailed": "Library fetch failed.",
  "library.error.syncConflict":
    "Remote sync conflict. Pull the latest version before retrying.",
  "library.error.syncFailed": "Library sync failed.",
  "library.error.syncUnavailable":
    "Library sync is unavailable because no worker URL is configured.",

  "manage.tabs.aria": "Manage section",
  "manage.tabs.cards": "Cards",
  "manage.tabs.decks": "Decks",
  "manage.tabs.heroes": "Heroes",

  "match.board.activeDestination": "→ Active",
  "match.board.activeLabel": "Active: {name}",
  "match.board.activeZone": "Active",
  "match.board.actionHint": "Play selected card:",
  "match.board.attackerHint":
    "Attacker selected: click opponent CC or unit to attack",
  "match.board.betterBattleBot": "Better Battle Bot 3/2 (",
  "match.board.cc": "CC",
  "match.board.cardTileTitle":
    "{attack}/{health}{guard, select, true { [Guard]} other {}}{exhausted, select, true { [Exhausted]} other {}}",
  "match.board.concede": "Concede",
  "match.board.deck": "Deck: {count}",
  "match.board.discard": "Discard: {count}",
  "match.board.empty": "Empty",
  "match.board.endTurn": "End turn →",
  "match.board.hand": "Hand ({count})",
  "match.board.heroLevel": "Hero L{level}",
  "match.board.jamHint":
    "Jam — click an opponent unit to lock it down for its next turn",
  "match.board.levelUpHero": "Level up hero ({cost}⚡)",
  "match.board.levelUpShort": "Lvl-up:",
  "match.board.matchOver": "Match over",
  "match.board.mercRow": "Merc row ({count} / 3 slots, cost ~",
  "match.board.newMatch": "New match",
  "match.board.quit": "Quit",
  "match.board.reason.centralCommandZero": "central command zero",
  "match.board.reason.concede": "concede",
  "match.board.reason.label": "Reason: {reason}",
  "match.board.reason.timeout": "timeout",
  "match.board.reconnecting":
    "Reconnecting to the match server. Commands are temporarily disabled.",
  "match.board.reconnectingBlocked":
    "Still reconnecting to the match server. Try again in a moment.",
  "match.board.recycleHint":
    "Recycle — click one of your cards in hand or play to discard it and draw 2 cards",
  "match.board.connectionUnstable":
    "Connection is unstable. Trying to recover the authoritative match state.",
  "match.board.opponentDisconnected":
    "Your opponent is disconnected. Timeout in about {seconds} seconds if they do not return.",
  "match.board.playerDisconnected": "Disconnected",
  "match.board.supply": "Supply: {count}",
  "match.board.supplyExhausted": "Supply exhausted",
  "match.board.supportDestination": "→ Support",
  "match.board.supportZone": "Support",
  "match.board.turn": "Turn {turn}",
  "match.board.turnStep.cleanup": "cleanup",
  "match.board.turnStep.draw": "draw",
  "match.board.turnStep.energy": "energy",
  "match.board.turnStep.main": "main",
  "match.board.turnStep.recover": "recover",
  "match.board.turnStep.start": "start",
  "match.board.timeout.youLose":
    "You lost because your connection did not recover in time.",
  "match.board.timeout.youWin":
    "You won because your opponent did not reconnect in time.",
  "match.board.turns": "Turns: {count}",
  "match.board.winner": "Winner: {name}",
  "match.error.ATTACK_ALREADY_ATTACKED":
    "This unit cannot attack again this turn.",
  "match.error.ATTACK_BLOCKED_BY_GUARD":
    "You must attack a Guard unit first unless you can bypass Guard.",
  "match.error.ATTACK_INVALID_TARGET_ZONE":
    "That unit is not in an attackable zone.",
  "match.error.ATTACK_NOT_IN_ATTACK_POSITION":
    "Only the active unit or a Ranged support unit can attack.",
  "match.error.ATTACK_NO_TARGET_ID": "Pick a target unit before attacking.",
  "match.error.ATTACK_SUPPORT_REQUIRES_BYPASS":
    "You need Guard bypass before attacking that support unit.",
  "match.error.ATTACK_UNKNOWN_ATTACKER":
    "The attacking unit could not be found.",
  "match.error.ATTACK_UNKNOWN_TARGET": "The target unit could not be found.",
  "match.error.CONCEDE_MATCH_OVER": "The match is already over.",
  "match.error.END_TURN_WRONG_STEP":
    "You can only end the turn during the main step.",
  "match.error.JAM_NO_TARGET": "Jam needs an enemy unit target.",
  "match.error.JAM_UNKNOWN_TARGET": "The Jam target could not be found.",
  "match.error.LEVEL_UP_HERO_DEF_NOT_FOUND":
    "The hero definition for this match could not be found.",
  "match.error.LEVEL_UP_HERO_EXHAUSTED":
    "The hero is exhausted and cannot level up this turn.",
  "match.error.LEVEL_UP_INSUFFICIENT_ENERGY":
    "You do not have enough energy to level up the hero.",
  "match.error.LEVEL_UP_NO_HERO_INSTANCE":
    "The hero instance could not be found.",
  "match.error.LEVEL_UP_WRONG_LEVEL":
    "Heroes must level up one level at a time.",
  "match.error.MATCH_COMPLETED": "The match is already completed.",
  "match.error.PLAY_CARD_ACTIVE_OCCUPIED":
    "The active slot is occupied. Swap first or play to support.",
  "match.error.PLAY_CARD_NOT_IN_HAND": "That card is no longer in your hand.",
  "match.error.PLAY_CARD_REPLACE_NOT_IN_SUPPORT":
    "The selected replacement card is not in support.",
  "match.error.PLAY_CARD_REPLACE_NOT_NEEDED":
    "Support replacement is only allowed when support is full.",
  "match.error.PLAY_CARD_SUPPORT_FULL":
    "Support is full. Replace a support unit first.",
  "match.error.PLAY_CARD_UNKNOWN_INSTANCE":
    "That card instance could not be found.",
  "match.error.RECYCLE_INVALID_TARGET":
    "Recycle can only target one of your cards in hand or in play.",
  "match.error.RECYCLE_NO_TARGET":
    "Recycle needs one of your cards as the target.",
  "match.error.RECRUIT_INSUFFICIENT_ENERGY":
    "You do not have enough energy to recruit that card.",
  "match.error.RECRUIT_NO_SLOT_ID": "Choose a merc row slot to recruit from.",
  "match.error.RECRUIT_SLOT_NOT_IN_ROW":
    "That recruit slot is no longer in a merc row.",
  "match.error.RECRUIT_UNKNOWN_INSTANCE":
    "That recruit card could not be found.",
  "match.error.SALVAGE_NO_DISCARD":
    "You need at least one card in your discard pile to use Salvage.",
  "match.error.SHIFT_NOT_IN_SUPPORT":
    "Shift can only be used from the support row.",
  "match.error.SHIFT_NO_ACTIVE": "There is no active unit to swap with.",
  "match.error.SWAP_ALREADY_USED":
    "You already used your normal swap this turn.",
  "match.error.SWAP_NOT_IN_SUPPORT": "That unit is not in your support row.",
  "match.error.UNKNOWN_COMMAND": "That match action is not recognized.",
  "match.error.USE_ABILITY_ALLY_REQUIREMENT":
    "This ability needs more allied units in play.",
  "match.error.USE_ABILITY_EXHAUSTED":
    "That unit is exhausted and cannot use this ability.",
  "match.error.USE_ABILITY_JAMMED":
    "That unit is jammed and cannot use exhausting abilities this turn.",
  "match.error.USE_ABILITY_NOT_ACTIVATED":
    "That skill is passive and cannot be activated directly.",
  "match.error.USE_ABILITY_NOT_OWNED":
    "The source unit must be one of your units in play.",
  "match.error.USE_ABILITY_UNKNOWN_SKILL": "That skill could not be found.",
  "match.error.USE_ABILITY_UNKNOWN_SOURCE":
    "The source unit could not be found.",
  "match.error.WRONG_SEAT": "It is not that seat's turn.",
  "match.error.WRONG_TURN": "This action was submitted for the wrong turn.",
  "match.page.backToSetup": "Back to setup",
  "match.page.connectionClosed":
    "The match connection was closed unexpectedly.",
  "match.page.connectionFailed": "Connection failed",
  "match.page.connecting": "Connecting to match {matchId}…",
  "match.page.joinByIdDescription":
    "Enter a match ID shared by your opponent to connect.",
  "match.page.joinId": "Match ID",
  "match.page.joinIdPlaceholder": "match_abc123",
  "match.page.joinOnline": "Join online match",
  "match.page.localHeading": "Local (pass-and-play)",
  "match.page.onlineHeading": "Join online match",
  "match.page.pageEyebrow": "Matches",
  "match.page.pageTitle": "Start a match",
  "match.page.player1": "Player 1",
  "match.page.player1Seat": "Player 1 (Seat A)",
  "match.page.player2": "Player 2",
  "match.page.player2Seat": "Player 2 (Seat B)",
  "match.page.seatA": "Seat A (Challenger)",
  "match.page.seatB": "Seat B (Challenged)",
  "match.page.startLocal": "Start local match",
  "match.page.vs": "vs",
  "match.page.yourSeat": "Your seat",
  "match.setup.error.cardNotFound":
    'Card "{cardId}" in deck "{deckName}" could not be found in the card library.',
  "match.setup.error.deckLoad": "Selected decks could not be loaded.",
  "match.setup.error.deckNotFound": 'Deck "{deckId}" could not be found.',
  "match.setup.error.deckWrongCardCount":
    'Deck "{deckName}" has {count} cards instead of 24.',
  "match.setup.error.heroNotFound":
    'The hero for deck "{deckName}" could not be found.',
  "match.setup.error.player1Deck": "Player 1 must select a deck.",
  "match.setup.error.player2Deck": "Player 2 must select a deck.",
  "match.socket.INVALID_JSON":
    "The match server received an invalid command payload.",
  "match.socket.MATCH_NOT_INITIALIZED":
    "The match has not been initialized on the server yet.",
  "match.socket.WS_CONNECTION_FAILED":
    "The websocket connection to the match server failed.",

  "match.hotSeat.readyTitle": "{name}'s turn",
  "match.hotSeat.playTurn": "Play turn",
  "match.hotSeat.opponentHand": "Opponent hand: {count}",
  "match.hotSeat.heading": "Hot seat",
  "match.hotSeat.deckLabel": "Deck (both players)",
  "match.hotSeat.startButton": "Start hot seat",

  "nav.admin.label": "Admin",
  "nav.admin.short": "AD",
  "nav.close": "Close navigation",
  "nav.manage.label": "Manage",
  "nav.manage.short": "MG",
  "nav.open": "Open navigation",
  "nav.play.label": "Play",
  "nav.play.short": "PL",
  "nav.primary": "Primary navigation",
  "nav.signIn": "Sign in",
  "nav.signInShort": "SI",
  "nav.stats.label": "Stats",
  "nav.stats.short": "ST",
  "nav.theme.dark": "Switch to dark mode",
  "nav.theme.light": "Switch to light mode",
  "nav.toggle.collapse": "Collapse navigation",
  "nav.toggle.expand": "Expand navigation",

  "notFound.body": "No screen is registered for {pathname}.",
  "notFound.title": "Route not found",

  "profile.create.description":
    "CraftForce uses gamer tags as the public identity for friend lookup and challenge flows.",
  "profile.create.title": "Create your player profile",
  "profile.displayNameError.blocked": "Display name contains blocked language.",
  "profile.displayNameError.length":
    "Display name must be between 1 and 30 characters.",
  "profile.displayNameLabel": "Display name",
  "profile.gamerTagError.blocked": "Gamer tag contains blocked language.",
  "profile.gamerTagError.characters":
    "Use only letters, numbers, hyphens, and underscores in gamer tags.",
  "profile.gamerTagError.length":
    "Gamer tag must be between 3 and 20 characters.",
  "profile.gamerTagError.taken": "That gamer tag is already taken.",
  "profile.gamerTagHelp":
    "3-20 characters. Letters, numbers, hyphens, and underscores only.",
  "profile.gamerTagLabel": "Gamer tag",
  "profile.gamerTagPlaceholder": "pilot_one",
  "profile.ready.body":
    "Your local player profile bootstrap is complete for this environment.",
  "profile.ready.title": "Profile ready",
  "profile.role.admin": "admin",
  "profile.role.player": "player",
  "profile.save": "Save profile",

  "settings.accessClass.bootstrapAdmin": "Admin bootstrap",
  "settings.accessClass.invitedPlayer": "Invited player",
  "settings.accessRequiredBody":
    "You do not have an active invite for this CraftForce environment.",
  "settings.accessRequiredTitle": "Access required",
  "settings.accountStanding.activeFlags": "Active moderation flags",
  "settings.accountStanding.latestAttempt": "Latest flagged attempt",
  "settings.accountStanding.level.good": "good",
  "settings.accountStanding.level.restricted": "restricted",
  "settings.accountStanding.level.warned": "warned",
  "settings.accountStanding.title": "Account standing",
  "settings.adminReview.actor": "Actor: {actor}",
  "settings.adminReview.created": "Created: {createdAt}",
  "settings.adminReview.description":
    "Pending text moderation incidents require admin review before follow-up action.",
  "settings.adminReview.empty": "No pending moderation incidents.",
  "settings.adminReview.pendingCount":
    "{count, plural, one {# pending} other {# pending}}",
  "settings.adminReview.title": "Moderation review",
  "settings.adminReview.type.card_name": "card name",
  "settings.adminReview.type.display_name": "display name",
  "settings.adminReview.type.gamer_tag": "gamer tag",
  "settings.adminReview.type.hero_name": "hero name",
  "settings.adminReview.unknownActor": "Unknown",
  "settings.adminReview.value": "Value: {value}",
  "settings.emailRequiredBody":
    "Your account needs a primary email address before CraftForce can load your profile.",
  "settings.emailRequiredTitle": "Email required",
  "settings.eyebrow.account": "Account",
  "settings.identity.title": "Clerk identity",
  "settings.language.description":
    "Choose the interface language. CraftForce stores the selection in this browser.",
  "settings.language.label": "Language",
  "settings.language.option.de-DE": "Deutsch",
  "settings.language.option.en-US": "English (US)",
  "settings.language.option.fr-FR": "Français",
  "settings.language.option.zh-Hans": "Chinese (Simplified)",
  "settings.language.option.zh-Hant": "Chinese (Traditional)",
  "settings.language.title": "Interface language",
  "settings.lede":
    "Manage your player profile, gamer tag, and account details.",
  "settings.loading": "Loading account…",
  "settings.reports.description":
    "Reports stay pending until an admin reviews them. They do not change account standing automatically in MVP.",
  "settings.reports.empty": "No pending user reports.",
  "settings.reports.headline": "{reporter} reported {reported}",
  "settings.reports.markReviewed": "Mark reviewed",
  "settings.reports.reason": "Reason: {reason}",
  "settings.reports.title": "User reports",
  "settings.safetyTelemetry.description":
    "Local MVP counts for moderation incidents and player reports.",
  "settings.safetyTelemetry.flaggedAccounts": "Flagged accounts",
  "settings.safetyTelemetry.incidents": "Incidents",
  "settings.safetyTelemetry.incidentsSummary":
    "{total} total / {pending, plural, one {# pending} other {# pending}}",
  "settings.safetyTelemetry.latestEvent": "Latest safety event",
  "settings.safetyTelemetry.reports": "Reports",
  "settings.safetyTelemetry.reportsSummary":
    "{total} total / {pending, plural, one {# pending} other {# pending}}",
  "settings.safetyTelemetry.title": "Safety telemetry",
  "settings.safetyTelemetry.uniqueReportedPlayers": "Unique reported players",
  "settings.safetyTelemetry.uniqueReporters": "Unique reporters",
  "settings.signInRequired":
    "Sign in to view your profile and account settings.",
  "settings.socialTelemetry.acceptedChallenges": "Accepted challenges",
  "settings.socialTelemetry.activePlayers": "Active players in challenges",
  "settings.socialTelemetry.admins": "Admins",
  "settings.socialTelemetry.challenges": "Challenges",
  "settings.socialTelemetry.challengesSummary":
    "{total} total / {pending, plural, one {# pending} other {# pending}}",
  "settings.socialTelemetry.description":
    "Local MVP counts for invited-player profiles and challenge activity.",
  "settings.socialTelemetry.latestChallenge": "Latest challenge",
  "settings.socialTelemetry.profiles": "Profiles",
  "settings.socialTelemetry.profilesSummary":
    "{total} total / {players, plural, one {# player} other {# players}}",
  "settings.socialTelemetry.title": "Social telemetry",
  "settings.title": "Settings",

  "skill.armor.description": "Reduce each hit to this unit by 1.",
  "skill.armor.name": "Armor",
  "skill.breakthrough.description":
    "When this unit destroys a target in combat, any leftover attack can be used to attack again this turn.",
  "skill.breakthrough.name": "Breakthrough",
  "skill.battery.description":
    "Exhaust: choose an amount up to your current energy; spend it and store it on this unit. At the start of your next turn, gain that amount +1. If this unit leaves play, the stored energy is lost.",
  "skill.battery.name": "Battery",
  "skill.broker.description": "Exhaust: gain 1 energy this turn.",
  "skill.broker.name": "Broker",
  "skill.charge.description":
    "While this unit is in support, it generates 1 energy at the start of your turn.",
  "skill.charge.name": "Charge",
  "skill.coordinated_strike.description":
    "While this unit is in support, your active unit gets +1 attack.",
  "skill.coordinated_strike.name": "Coordinated Strike",
  "skill.deploy.description":
    "When you play this unit, deal 1 damage to the enemy active unit.",
  "skill.deploy.name": "Deploy",
  "skill.focus.description": "When this unit attacks, gain 1 energy.",
  "skill.focus.name": "Focus",
  "skill.generator.description":
    "While this unit is in support, each of your Charge units in support generates +1 energy at the start of your turn.",
  "skill.generator.name": "Generator",
  "skill.guard.description":
    "While you control a Guard, enemy attacks must target a Guard unless they bypass Guard.",
  "skill.guard.name": "Guard",
  "skill.jam.description":
    "Exhaust: target enemy unit cannot attack or use exhausting skills on its next turn.",
  "skill.jam.name": "Jam",
  "skill.ko.description": "When this unit destroys an enemy, draw a card.",
  "skill.ko.name": "Knockout",
  "skill.rally.description":
    "Exhaust: this unit gets +1 attack until end of turn.",
  "skill.rally.name": "Rally",
  "skill.ranged.description": "This unit can attack from the support row.",
  "skill.ranged.name": "Ranged",
  "skill.recover.description": "Exhaust: ready your active unit.",
  "skill.recover.name": "Recover",
  "skill.recycle.description":
    "Exhaust: discard one of your cards from your hand or board, then draw 2 cards.",
  "skill.recycle.name": "Recycle",
  "skill.repair.description":
    "Exhaust: this unit gets +2 health until after your opponent's next turn.",
  "skill.repair.name": "Repair",
  "skill.salvage.description":
    "Exhaust: return the top card of your discard pile to your hand.",
  "skill.salvage.name": "Salvage",
  "skill.scout.description": "Exhaust: draw a card.",
  "skill.scout.name": "Scout",
  "skill.scrap.description": "Exhaust: scrap this unit and draw a card.",
  "skill.scrap.name": "Scrap",
  "skill.shield.description":
    "Exhaust: your active unit gets +1 health until after your opponent's next turn.",
  "skill.shield.name": "Shield",
  "skill.shift.description":
    "Exhaust: move this unit between the active and support rows.",
  "skill.shift.name": "Shift",
  "skill.sneak.description":
    "When this unit attacks, it can ignore Guard and target Central Command or any unit.",
  "skill.sneak.name": "Sneak",
  "skill.spark.description": "When you play this unit, gain 1 energy.",
  "skill.spark.name": "Spark",
  "skill.swift.description":
    "This unit can attack the turn it enters the active slot or is swapped into it.",
  "skill.swift.name": "Swift",

  "skillsEditor.addSkill": "Add skill",
  "skillsEditor.ally.noneHelp": "No allied board requirement.",
  "skillsEditor.ally.oneHelp": "Requires 1 other allied unit in play.",
  "skillsEditor.ally.twoHelp": "Requires 2 other allied units in play.",
  "skillsEditor.allyRequirement": "Ally requirement",
  "skillsEditor.closeAria": "Close skill picker",
  "skillsEditor.detail.baseCost": "Base cost",
  "skillsEditor.detail.empty": "Hover a skill to see its description.",
  "skillsEditor.detail.previewAlly": "{sign} {cost} ally requirement",
  "skillsEditor.detail.previewBase": "Base: {cost}",
  "skillsEditor.detail.previewMode": "{sign} {cost} mode",
  "skillsEditor.emptyFilter": "No skills match.",
  "skillsEditor.filterPlaceholder": "Filter skills",
  "skillsEditor.heading": "Skills",
  "skillsEditor.locked": "Locked",
  "skillsEditor.mode.defaultHelp":
    "Exhausting. Standard use that spends the unit for the turn.",
  "skillsEditor.mode.nonExhaustingHelp":
    "Non-exhausting. Does not spend the unit.",
  "skillsEditor.mode.selfDestructHelp":
    "Overload. Use this skill, then scrap the unit.",
  "skillsEditor.removeAria": "Remove {name}",
  "skillsEditor.skillType.activatable": "Activatable",
  "skillsEditor.skillType.passive": "Passive",
  "skillsEditor.toggleAlly.none": "No ally required",
  "skillsEditor.toggleAlly.one": "Ally required",
  "skillsEditor.toggleAlly.two": "Double ally required",
  "skillsEditor.toggleAllyAria": "Toggle ally requirement for {name}",
  "skillsEditor.toggleMode.default": "Normal (exhausting)",
  "skillsEditor.toggleModeAria": "Toggle mode for {name}",
  "skillsEditor.useMode": "Use mode",
  "skillsEditor.wrongAffinity": "Wrong affinity",

  "stats.body": "Balance analytics and match history coming soon.",
  "stats.title": "Stats",

  "table.bulk.clearSelection": "Clear selection",
  "table.bulk.randomize": "Randomize",
  "table.bulk.syncSelection": "Sync selected",
  "table.cards.assignToDeck": "Assign to deck",
  "table.cards.create": "Create card",
  "table.cards.eyebrow": "Cards",
  "table.cards.lede":
    "Create, edit, duplicate, and delete cards. Skills are filtered by faction affinity. Cost is derived live from stats and skills.",
  "table.cards.selectAll": "Select all cards",
  "table.cards.title": "Card Library",
  "table.column.actions": "Actions",
  "table.column.name": "Name",
  "table.decks.create": "Create deck",
  "table.decks.entries": "Entries",
  "table.decks.eyebrow": "Decks",
  "table.decks.lede":
    "Build decks from the card library and assign a hero to each deck.",
  "table.decks.selectAll": "Select all decks",
  "table.decks.title": "Deck library",
  "table.heroes.create": "Create hero",
  "table.heroes.eyebrow": "Heroes",
  "table.heroes.factions": "Factions",
  "table.heroes.lede":
    "Create and manage three-level hero progressions assigned to decks.",
  "table.heroes.progression": "L1 / L2 / L3",
  "table.heroes.selectAll": "Select all heroes",
  "table.heroes.title": "Hero library",
  "table.transfer.download": "Download backup",
  "table.transfer.downloadSuccess":
    "{count, plural, one {Downloaded backup with # record.} other {Downloaded backup with # records.}}",
  "table.transfer.dropBody": "Release to import a backup file into this table.",
  "table.transfer.dropTitle": "Import {table} backup",
  "table.transfer.error.compressionUnsupported":
    "This browser cannot compress or extract library backup files.",
  "table.transfer.error.generic":
    "The library backup could not be processed. Try again.",
  "table.transfer.error.invalidArchive":
    "The selected file is not a valid CraftForce library backup.",
  "table.transfer.error.kindMismatch":
    "This backup is for {actual}, not {expected}.",
  "table.transfer.hint":
    "Drag a compressed backup onto the table to import it. Select rows to download a backup.",
  "table.transfer.upload": "Import backup",
  "table.transfer.uploadSuccess":
    "Imported backup. {added, plural, one {# record added} other {# records added}}, {updated, plural, one {# updated} other {# updated}}, {skipped, plural, one {# skipped} other {# skipped}}.",
  "table.sync.conflict": "Conflict",
  "table.row.openActions": "Open actions for {name}",
  "table.row.select": "Select {name}",
  "table.rowAction.cancelDelete": "Cancel delete {name}",
  "table.rowAction.confirmDelete": "Confirm delete {name}",
  "table.rowAction.delete": "Delete {name}",
  "table.rowAction.duplicate": "Duplicate {name}",
  "table.rowAction.edit": "Edit {name}",
  "table.rowAction.pullRemote": "Pull latest remote version of {name}",
  "table.rowAction.sync": "Sync {name}",
  "table.origin.local": "Local draft",
  "table.refresh.failed": "Remote refresh failed. Showing cached data.",
  "table.refresh.idle": "Working from the local cache.",
  "table.refresh.last": "Remote refreshed {time}",
  "table.refresh.offline": "Offline. Using local cached data.",

  "ui.artwork.addImage": "Add image",
  "ui.artwork.dropBodyBusy": "Please wait until the current upload finishes.",
  "ui.artwork.dropBodyIdle":
    "Transparency is preserved and images are stored locally as WebP variants.",
  "ui.artwork.dropTitleBusy": "Processing image...",
  "ui.artwork.dropTitleEmpty": "Drop an image here or click to upload",
  "ui.artwork.dropTitleReplace": "Drop a new image here to replace it",
  "ui.artwork.error.canvasUnavailable":
    "Artwork processing could not create a canvas context.",
  "ui.artwork.error.dataUrlFailed":
    "Artwork processing could not produce a data URL.",
  "ui.artwork.error.decodeFailed": "The selected artwork could not be decoded.",
  "ui.artwork.error.heicUnsupported":
    "This browser could not decode the selected HEIC or HEIF image. Try JPEG, PNG, or WebP instead.",
  "ui.artwork.error.encodeFailed":
    "Artwork processing could not encode the image.",
  "ui.artwork.error.fileTooLarge": "The selected artwork file is too large.",
  "ui.artwork.error.invalidDimensions":
    "The selected artwork dimensions exceed the allowed limits.",
  "ui.artwork.error.invalidUpload":
    "The selected artwork is not a valid upload.",
  "ui.artwork.error.noLocalVariants":
    "No local artwork variants are available to sync.",
  "ui.artwork.error.noVariants":
    "Artwork processing did not produce any image variants.",
  "ui.artwork.error.readFailed":
    "Artwork processing could not read the image data.",
  "ui.artwork.error.sourceUnavailable":
    "Artwork processing could not access the image source.",
  "ui.artwork.error.syncFailed": "Artwork sync to the server failed.",
  "ui.artwork.error.syncUnavailable":
    "Artwork sync is unavailable because no worker URL is configured.",
  "ui.artwork.error.turnstileFailed":
    "Human verification failed, so the artwork stayed local only.",
  "ui.artwork.error.turnstileRequired":
    "Human verification is required before this artwork can sync to the server.",
  "ui.artwork.error.turnstileUnavailable":
    "Human verification could not be loaded, so the artwork stayed local only.",
  "ui.artwork.error.unsupportedExtension":
    "The selected artwork file extension is not supported.",
  "ui.artwork.error.unsupportedMimeType":
    "The selected artwork file type is not supported.",
  "ui.artwork.error.uploadFailed": "Artwork upload failed.",
  "ui.artwork.focus": "Focus",
  "ui.artwork.focusPointTitle": "Focus {x}% / {y}%",
  "ui.artwork.help":
    "JPEG, PNG, WebP, HEIC, HEIF, or GIF. Stored locally as WebP variants.",
  "ui.artwork.noArtwork": "No artwork uploaded yet",
  "ui.artwork.preparing": "Preparing WebP variants...",
  "ui.artwork.processing": "Processing image...",
  "ui.artwork.ready": "Artwork ready",
  "ui.artwork.removeImage": "Remove image",
  "ui.artwork.replaceImage": "Replace image",
  "ui.artwork.sync.localOnly": "Saved locally only. Server sync unavailable.",
  "ui.artwork.sync.retrying": "Retrying server sync...",
  "ui.artwork.sync.synced": "Synced to server.",
  "ui.artwork.sync.syncing": "Syncing to server...",
  "ui.artwork.retrySync": "Retry sync",
  "ui.artwork.retrying": "Retrying…",
  "ui.artwork.zoom": "Zoom",
  "ui.artwork.zoomAria": "Artwork zoom",
  "ui.artwork.zoomReset": "Reset",
} as const
